import React from 'react';
import MealPage from './MealPage';
import { colors } from '../theme';
import { MEAL_LABELS } from '../constants/mealLabels';

const DinnerPage = () => (
  <MealPage mealtime="dinner" title={MEAL_LABELS.dinner} accentColor={colors.meal.dinner} />
);

export default DinnerPage;
